/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoMortoUpdateDTO
 */
export interface MovimentoMortoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoMortoUpdateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoMortoUpdateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMortoUpdateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMortoUpdateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMortoUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMortoUpdateDTO
     */
    idIncubatoio?: number | null;
}

/**
 * Check if a given object implements the MovimentoMortoUpdateDTO interface.
 */
export function instanceOfMovimentoMortoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoMortoUpdateDTOFromJSON(json: any): MovimentoMortoUpdateDTO {
    return MovimentoMortoUpdateDTOFromJSONTyped(json, false);
}

export function MovimentoMortoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoMortoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'idIncubatoio': !exists(json, 'idIncubatoio') ? undefined : json['idIncubatoio'],
    };
}

export function MovimentoMortoUpdateDTOToJSON(value?: MovimentoMortoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'idIncubatoio': value.idIncubatoio,
    };
}

